<template>
    <div>
        <v-menu v-model="showMenu" :close-on-content-click="false">
            <template v-slot:activator="{props}">
                <v-btn color="primary" variant="text" data-cy="file-excel" icon="mdi-file-excel" v-bind="props" />
            </template>
            <v-card>
                <v-card-title v-if="label">{{ label }}</v-card-title>
                <v-card-text v-if="radioItems?.length">
                    <v-radio-group
                        v-model="radioGroup"
                        density="compact"
                        hide-details
                        class="mt-0"
                        @update:model-value="changeRadioGroup"
                    >
                        <v-radio
                            v-for="radioItem in radioItems"
                            :key="radioItem.value"
                            color="primary"
                            :data-cy="`radio-${radioItem}`"
                            :label="radioItem.label"
                            :disabled="radioItem.disabled"
                            :value="radioItem.value"
                        />
                    </v-radio-group>
                </v-card-text>
                <v-card-actions class="px-4">
                    <div class="d-flex align-center">
                        <span class="text-caption">{{ $t('download') }}:</span>
                        <div class="">
                            <v-tooltip v-for="format in formats" :key="format.fileType" location="top">
                                <template v-slot:activator="{props}">
                                    <v-btn
                                        :disabled="isDisabled"
                                        :loading="loading"
                                        :icon="format.icon"
                                        :color="'primary'"
                                        variant="text"
                                        v-bind="props"
                                        data-cy="download"
                                        @click="download(format)"
                                    />
                                </template>
                                <span>{{ format.fileType }}</span>
                            </v-tooltip>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-menu>
    </div>
</template>

<script lang="ts">
    import {Component, Emit, Prop, VModel, Vue} from 'vue-facing-decorator'

    @Component
    export class FileDownloadModal extends Vue {
        @VModel() showMenu
        @VModel({default: ''}) radioGroup
        @Prop() label
        @Prop({default: false}) loading
        @Prop({
            default: () => [
                {
                    fileType: 'EXCEL',
                    icon: 'mdi-file-excel',
                    extension: 'xlsx',
                },
            ],
        })
        formats
        @Prop({
            default: () => [
                {
                    value: 'selected',
                    label: 'only_selected_label',
                    disabled: false,
                },
                {value: 'all', label: 'all_label'},
            ],
            required: true,
        })
        radioItems

        @Emit()
        download(format) {
            return format
        }

        @Emit()
        changeRadioGroup(val) {
            return val
        }

        get isDisabled() {
            return this.radioGroup === '' || this.loading
        }
    }

    export default FileDownloadModal
</script>
